export default "__VITE_ASSET__BvYS2QSH__"